// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDigitalAssetRequestModel from '../../model/get-digital-asset-request-model';
import GetDigitalAssetRequestDTO from '../dto/get-digital-asset-request-dto';
import dtoSchema from '../schemas/get-digital-asset-request-schema';

export default abstract class GetDigitalAssetRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDigitalAssetRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetDigitalAssetRequestDTO>): GetDigitalAssetRequestModel;
  static toModel(dto: DeepPartial<GetDigitalAssetRequestDTO> | undefined | null): GetDigitalAssetRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDigitalAssetRequestDTO> | undefined | null): GetDigitalAssetRequestModel | undefined {
    return dto ? new GetDigitalAssetRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDigitalAssetRequestModel> | GetDigitalAssetRequestModel): GetDigitalAssetRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetDigitalAssetRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDigitalAssetRequestModel, can not map to GetDigitalAssetRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
